export default {
      id: "build-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#build-usage",
      toString: function () {
        return this.url;
      }
    }